import http from '@/server/httpServer.js'

/**
 * 人员管理
 * @return {promise}
 *
 */
/* 人员列表 */
export const listBackstageUser = (data) => {
    return http({ url: '/scavenger/backstageUser/listBackstageUser', method: 'post' }, data)
}

/* 新增人员 */
export const insertBackstageUser = (data) => {
    return http({ url: '/scavenger/backstageUser/insertBackstageUser', method: 'post' }, data)
}

/* 修改人员 */
export const updateBackstageUser = (data) => {
    return http({ url: '/scavenger/backstageUser/updateBackstageUser', method: 'post' }, data)
}

/* 启用状态修改 */
export const updateBackstageUserStatus = (data) => {
    return http({ url: '/scavenger/backstageUser/updateBackstageUserStatus', method: 'post' }, data)
}

/* 删除人员 */
export const deleteBackstageUser = (data) => {
    return http({ url: `/scavenger/backstageUser/deleteBackstageUser/${data.userId}`, method: 'post' }, data)
}